import styled from "styled-components";
import DropdownOption from "../Components/DropdownOption.jsx";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";

import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MoreBtn from "../Components/MoreBtn.jsx";
import Layout from "../Layout/Layout.jsx";
import Pagination from "../Layout/Pagination.jsx";
import Rankings from "../Modals/Rankings.jsx";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils.js";
import { compareDates } from "../Utils/numberUtils.js";
import { showToast } from "../Utils/variables.js";

const OurContestManageContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [total_contest, setTotal_contest] = useState(0);
  const [contest_list, setContest_list] = useState([]);
  const [page, setPage] = useState(1);
  const offset = 10;

  const [searchTitle, setSearchTitle] = useState("");
  const [battleType, setBattleType] = useState(null);
  const [progressStatus, setProgressStatus] = useState(null);
  const [meetWeId, setMeetWeId] = useState(null);

  const [clickRankings, setClickRankings] = useState(false);
  const [battleType_forRanking, setBattleType_forRanking] = useState(null);
  const [contestTitle, setContestTitle] = useState("");
  const [clickInput, setClickInput] = useState(false);
  const lastContestRequestKey = useRef(null);

  const getContestList = async () => {
    try {
      const _battleType =
        battleType === "만보기(팀전)"
          ? 1
          : battleType === "만보기(개인전)"
          ? 0
          : null;
      const _progressStatus =
        progressStatus === "진행전"
          ? 0
          : progressStatus === "진행중"
          ? 1
          : progressStatus === "종료"
          ? 2
          : null;
      const body = {
        page,
        offset,
        searchTitle,
        battleType: _battleType,
        progressStatus: _progressStatus,
      };

      const data = await postJson(
        "/dashboard/meetWe/getList",
        body,
        navigate
      );

      if (data.code === 200) {
        setTotal_contest(data.data.count);
        setContest_list(data.data.rows);
      }
    } catch (error) {
      console.log("우리끼리대회 리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ battleType, progressStatus, page });

    if (lastContestRequestKey.current === requestKey) {
      return;
    }

    lastContestRequestKey.current = requestKey;
    getContestList();
  }, [battleType, progressStatus, page]);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast(
        location.state.toast_message ?? "우리끼리 대회가 수정되었습니다.",
        "success"
      );
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleClickRankingBtn = (id, type, title) => {
    setClickRankings(true);
    setMeetWeId(id);
    setBattleType_forRanking(type);
    setContestTitle(title);
  };

  return (
    <div>
      {clickRankings && (
        <Rankings
          title="랭킹 간략히 보기"
          infotext="이벤트 대회는 기간 내 누적 걸음 수로 산정합니다."
          contestType="우리끼리 대회"
          contestTitle={contestTitle}
          ourcontestType={battleType_forRanking}
          handleClickX={() => setClickRankings(false)}
          id={meetWeId}
        />
      )}
      {/* 우리끼리 대회 관리 박스 */}
      <ContestBox>
        <div className="title-in-box">우리끼리 대회 관리</div>
        {/* 검색창 | 드롭다운 옵션 3개 */}
        <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
          {/* 검색창 */}
          <div
            className="searchBox"
            style={{ boxShadow: clickInput ? "inset 0 0 0 1px #1167ed" : "" }}
          >
            <input
              type="text"
              placeholder="대회명, 대회 종류"
              onChange={(e) => setSearchTitle(e.target.value)}
              onClick={() => setClickInput(true)}
              onBlur={() => setClickInput(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getContestList();
                }
              }}
            />
            <IconSearch
              style={{ cursor: "pointer" }}
              onClick={getContestList}
            />
          </div>

          {/* 드롭다운 옵션 */}
          <div style={{ display: "flex", marginLeft: "auto" }}>
            <DropdownOption
              title="대회 종류"
              dropdown_list={["만보기(팀전)", "만보기(개인전)"]}
              optionChange={(value) => setBattleType(value)}
            />
            <DropdownOption
              title="진행 상태"
              dropdown_list={["진행전", "진행중", "종료"]}
              optionChange={(value) => setProgressStatus(value)}
            />
          </div>
        </div>

        {/* 전체 대회 건수 */}
        <div
          className="hrz-wrapper"
          style={{ marginTop: "30px", color: "#000000" }}
        >
          전체 {total_contest?.toLocaleString()}건
        </div>

        {/* 대회 리스트 */}
        <div className="listArea" style={{ marginTop: "10px" }}>
          {/* 라벨 */}
          <div
            className="list_titleBar"
            style={{
              gridTemplateColumns:
                "100px 280px 100px 120px 120px 220px 220px 230px 58px 52px",
            }}
          >
            <p className="center">NO</p>
            <p className="leftalign">대회명</p>
            <p className="leftalign">카테고리</p>
            <p className="leftalign">대회 종류</p>
            <p className="leftalign">진행 상태</p>
            <p className="leftalign">대회 기간</p>
            <p className="leftalign">등록일</p>
          </div>

          {/* 데이터 */}
          {contest_list.slice(0, 10).map((data) => (
            <ContestData
              key={data.rownum}
              rownum={data.rownum}
              meetWeId={data.meetWeId}
              title={data.title}
              officialType={data.officialType}
              battleType={data.battleType}
              cStartTime={data.cStartTime}
              cEndTime={data.cEndTime}
              regTime={data.regTime}
              canEdit={data.canEdit}
              onClickRankings={handleClickRankingBtn}
            />
          ))}
        </div>

        {/* 페이징 */}
        <Pagination
          totalPages={total_contest === 0 ? 1 : Math.ceil(total_contest / 10)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />
      </ContestBox>
    </div>
  );
};

const ContestData = ({
  rownum,
  title,
  officialType,
  battleType,
  cStartTime,
  cEndTime,
  regTime,
  meetWeId,
  canEdit,
  onClickRankings,
}) => {
  const periodDate = cStartTime + "~" + cEndTime;

  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns:
          "100px 280px 100px 120px 120px 220px 220px 230px 58px 52px",
      }}
    >
      <p className="center">{rownum}</p>

      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{title}</p>
      </div>

      <p className="leftalign">{officialType === 1 ? "공식" : "일반"}</p>

      <p className="leftalign">
        {battleType === 0 ? "만보기(개인전)" : "만보기(팀전)"}
      </p>

      <p className="leftalign">
        {compareDates(cStartTime) === 1
          ? "진행전"
          : (compareDates(cStartTime) === -1 ||
              compareDates(cStartTime) === 0) &&
            (compareDates(cEndTime) === 1 || compareDates(cEndTime) === 0)
          ? "진행중"
          : compareDates(cEndTime) === -1
          ? "종료"
          : ""}
      </p>

      <p className="leftalign">{periodDate}</p>
      <p className="leftalign">{regTime}</p>
      <div />

      <div className="center">
        <div
          className="blueBorderBtn-58x39 center"
          onClick={() => onClickRankings(meetWeId, battleType, title)}
        >
          랭킹
        </div>
      </div>

      <div className="center">
        <MoreBtn
          option1={canEdit ? "수정" : "상세"}
          option2=""
          option1Addr={
            canEdit ? `/meetWe/edit/${meetWeId}` : `/meetWe/detail/${meetWeId}`
          }
        />
      </div>
    </div>
  );
};

const ContestBox = styled.div`
  width: 1500px;
  height: auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin: 30px;
`;

const OurContestManage = () => {
  return <Layout page={<OurContestManageContent />} />;
};

export default OurContestManage;
